var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component",staticClass:"LINK"},'component',_vm.propsFor(_vm.componentName),false),[_vm._t("default"),(_vm.exact)?_c('vk-icon',{staticClass:"d-none:t c-depot",attrs:{"name":"chevronright"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }